// extracted by mini-css-extract-plugin
module.exports = {"modal":"Referral_modal__QUxFB"};